import { frozenPanel, setPanelState, setPopupPanel } from "../../../Engine/ActionCreators/HiddenPanelActionCreators";
import { CandyThunkAction } from "../../../Engine/Core/Store/CandyReduxTypes";
import { PanelType } from "../Panel/PanelTypes";

import { Data, Events, GroupActions, Step } from "./TourTypes";

const panel: GroupActions = {
    before: (data: Data) => (dispatch, getState) => {
        const state = getState();

        data.set("oldPanelState", state.formVisualState.panelState);

        if (state.formVisualState.panelState !== "hide") {
            dispatch(frozenPanel(true));

            return Promise.resolve();
        }

        dispatch(setPanelState("show"));
        dispatch(frozenPanel(true));

        return new Promise((resolve: () => void) => {
            setTimeout(resolve, 1000);
        });
    },
    after: (data: Data) => dispatch => {
        const oldPanelState: PanelType = data.get("oldPanelState");
        const nextPanelState = oldPanelState === "show" ? "hide" : oldPanelState;

        dispatch(frozenPanel(false));
        data.remove("oldPanelState");

        if (nextPanelState !== "hide") {
            return Promise.resolve();
        }

        dispatch(setPanelState(nextPanelState));

        return new Promise((resolve: () => void) => {
            setTimeout(resolve, 1000);
        });
    },
};

const menu: GroupActions = {
    before: (_data: Data) => dispatch => {
        dispatch(setPopupPanel(true, true));

        return new Promise((res: () => void) => {
            setTimeout(res, 100);
        });
    },
    after: (_data: Data) => dispatch => {
        dispatch(setPopupPanel(false, false));

        return Promise.resolve();
    },
};

const details: GroupActions = {
    before: (data: Data) => () => {
        data.get("currStep").control.props.disableHover();

        return undefined;
    },
    after: (data: Data) => () => {
        data.get("prevStep").control.props.enableHover();

        return undefined;
    },
};

const events: Events = {
    panel: panel,
    menu: menu,
    details: details,
};

export function beforeTourAction({ group = [] }: Step): CandyThunkAction {
    return (dispatch, getState) => {
        const state = getState();

        if (!group.includes("panel") && state.formVisualState.panelState === "show") {
            dispatch(setPanelState("hide"));
        }

        if (!group.includes("menu")) {
            dispatch(setPopupPanel(false));
        }
    };
}

export { events };
